import React from "react";
import FormikSearchSelector from 'gui/components/formikSearchSelector/FormikSearchSelector';
import {SelectOption} from 'react-select-material-ui';

export interface ISelectorProps {
  label: string;
  mealTypes: SelectOption[];
}


const RoomMealSelector = (props: ISelectorProps) => {
  return (
    <FormikSearchSelector
      options={props.mealTypes}
      isSearchable={false}
      isClearable={false}
      {...props}
    />
  );
};

export const mealTypes = [
  "לינה בלבד"
  , "ארוחת בוקר"
  , "חצי פנסיון"
  , "פנסיון מלא"
  , "הכל כלול"
].map((meal, index) => ({label: `${meal}`, value: index + 1}));
RoomMealSelector.defaultProps = {
  mealTypes
};

export default React.memo(RoomMealSelector);
